
<div class="measurement_conversion">
  <p class="title">Measurement conversion</p>
  <div class="conversion">
    <p class="convert">
      <span class="Unit">Unit</span>
      <span class="value">Value</span>
    </p>
    <p class="convert">
      <span>Hectare</span>
      <span class="value">{{selectedLandTitle.LHectares}}</span>
    </p>
    <p class="convert">
      <span class="Unit">Acre</span>
      <span class="value">{{selectedLandTitle.LAcres}}</span>
    </p>
    <p class="convert">
      <span class="Unit">SqKm</span>
      <span class="value">{{selectedLandTitle.LSqKilometers}}</span>
    </p>

    <p class="convert">
      <span class="Unit">SqM</span>
      <span class="value">{{selectedLandTitle.LSqMeters}}</span>
    </p>

    <p class="convert">
      <span class="Unit">SqF</span>
      <span class="value">{{selectedLandTitle.LSqFeet}}</span>
    </p>


    <p class="convert">
      <span class="Unit">Rood</span>
      <span class="value">{{selectedLandTitle.LRoods}}</span>
    </p>
    <p class="convert">
      <span class="Unit">Perche</span>
      <span class="value">{{selectedLandTitle.LPerche}}</span>
    </p>
    <p class="convert">
      <span class="Unit">Plot</span>
      <span class="value">{{selectedLandTitle.LPlot}}</span>
    </p>
  </div>
</div>
